import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import './Navbar.css';
import { authService } from '../../services/authService';
import { ROUTES } from "../../utils/constants";
import logo from "../../assets/image/logo.png";
import homepic from "../../assets/image/home.png";
import GoToPage from '../Common/GoToPage';
import NotificationBell from '../Common/NotificationBell';

interface NavbarProps {
  onToggleSidebar?: () => void;
}

// role_name as stored on cc_user_roles isn't always display-ready
// ('pc_manager', 'qa') - curated labels for the roles that need one, a
// generic underscore-to-title-case fallback for anything else.
const ROLE_LABEL: Record<string, string> = {
  admin: 'Admin',
  pc_manager: 'PC Manager',
  pc: 'PC',
  qa: 'QA',
  fulfillment: 'Fulfillment',
};

const roleLabel = (roleName?: string): string => {
  if (!roleName) return '';
  if (ROLE_LABEL[roleName]) return ROLE_LABEL[roleName];
  return roleName.replace(/_/g, ' ').replace(/\w\S*/g, (w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase());
};

const Navbar: React.FC<NavbarProps> = ({ onToggleSidebar }) => {
  const navigate = useNavigate();
  const [showDropdown, setShowDropdown] = useState(false);

  // Mock user for now - replace with useAuthContext when auth is fully implemented
  // const user = { name: 'User', userRole: 'Admin', avatar: '' };
  const user = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user") as string)
    : null;

  const handleLogout = async () => {
    try {
      await authService.logout(); // Call backend logout
    } catch (error) {
      console.error("Logout API failed:", error);
    } finally {
      // ✅ Always clear tokens (even if logout API fails)
      localStorage.removeItem("accessToken");
      localStorage.removeItem("refreshToken");
      localStorage.removeItem("role_id");
      localStorage.removeItem("userId");
      localStorage.removeItem("email");
      localStorage.removeItem("permissions");

      // ✅ Redirect user to sign-in page
      navigate(ROUTES.SIGNIN, { replace: true });
    }
  };


  return (
    <nav className="navbar" style={{ padding:"0"}}>
      <div className="navbar-left">
        <img src={logo} alt="Corecrate Logo" onClick={() => navigate(ROUTES.DASHBOARD)} style={{ height: "30px",cursor: "pointer"  }} className='ml-4' />
        <img src={homepic} onClick={() => navigate(ROUTES.DASHBOARD)} style={{ background: "transparent",cursor: "pointer" }} />

      </div>
      {/* <GoToPage /> */}
      <div className="navbar-right mr-4" style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <NotificationBell />
        <div className="navbar-user" onClick={() => setShowDropdown(!showDropdown)}>
          <div className="user-avatar">
            {user?.avatar ? (
              <img src={user.avatar} alt={user.first_name} />
            ) : (
              <span>{user ? user.first_name.charAt(0).toUpperCase() : 'P'}</span>
            )}
          </div>
          <div className="user-info">
            <span className="user-name">{(() => {
              const raw = user?.first_name || 'User';
              return raw.charAt(0).toUpperCase() + raw.slice(1);
            })()}</span>
            {user?.role_name && <span className="user-role">{roleLabel(user.role_name)}</span>}
          </div>
          <svg width="12" height="12" viewBox="0 0 12 12" fill="currentColor">
            <path d="M6 9L1 4H11L6 9Z" />
          </svg>

          {showDropdown && (
            <div className="user-dropdown">
              {/* <div className="dropdown-divider"></div> */}
              <button onClick={handleLogout} className="dropdown-item">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M6 14H3.33333C3.15652 14 2.98695 13.9298 2.86193 13.8047C2.7369 13.6797 2.66667 13.5101 2.66667 13.3333V2.66667C2.66667 2.48986 2.7369 2.32029 2.86193 2.19526C2.98695 2.07024 3.15652 2 3.33333 2H6M10.6667 11.3333L14 8M14 8L10.6667 4.66667M14 8H6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
                Sign Out
              </button>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
